'use client';
import { MdClose } from 'react-icons/md';
import { tokenToLamports, lamportsToToken } from '@/lib/utils';

export default function PendingBidRow({ amt, qty, token, decimals, onDelete }) {
  const total = lamportsToToken(decimals, tokenToLamports(decimals, amt) * qty);
  return (
    <div className="flex items-center justify-between border border-neutral px-2 py-1">
      <p>
        {qty} bids × {amt} {token === 'SOL' ? '◎' : token}
      </p>
      <div className="flex items-center space-x-2">
        <p>
          {total} {token === 'SOL' ? '◎' : token}
        </p>
        <button className="btn btn-square btn-sm btn-ghost" onClick={onDelete}>
          <MdClose />
        </button>
      </div>
    </div>
  );
}
